import { render, staticRenderFns } from "./Feature.vue?vue&type=template&id=6e32610f"
import script from "./Feature.vue?vue&type=script&lang=ts"
export * from "./Feature.vue?vue&type=script&lang=ts"
import style0 from "./Feature.vue?vue&type=style&index=0&id=6e32610f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports